import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { RootState } from "../../store/combineReducer";
import BillingConditionsTab from "./BillingConditionsTab";
import MovementsTab from "./MovementsTab";
import CommunicationsTab from "./CommunicationsTab";
import "./gestiones_comerciales.scss";

const PAGE_TABS = [
  {
    id: "condiciones",
    label: "Condiciones de facturación y políticas operativas",
  },
  { id: "movimientos", label: "Movimientos" },
 // { id: "comunicaciones", label: "Comunicaciones" },
];

const GestionesComercialesContent = () => {
  const [searchParams, setSearchParams] = useSearchParams("");
  const [currentTab, setCurrentTab] = useState(
    searchParams.get("currentTab") || PAGE_TABS[0].id,
  );
  const [movimientosMountKey, setMovimientosMountKey] = useState(0);

  useEffect(() => {
    const tabFromUrl = searchParams.get("currentTab");
    if (tabFromUrl) {
      setCurrentTab(tabFromUrl);
    }
  }, [searchParams]);

  const handleChangeTab = (tab: string) => {
    if (tab === "movimientos") {
      setMovimientosMountKey((key) => key + 1);
    }
    setCurrentTab(tab);
    setSearchParams({ currentTab: tab });
  };

  const renderTabContent = () => {
    switch (currentTab) {
      case "condiciones":
        return <BillingConditionsTab />;
      case "movimientos":
        return <MovementsTab key={movimientosMountKey} />;
      case "comunicaciones":
        return <CommunicationsTab />;
      // default:
      //   return <BillingConditionsTab />;
    }
  };

  return (
    <div className="main-container">
      <div className="atendoo-card">
        <div className="users-roles-header">
          <h6 className="subtitle">Gestiones comerciales</h6>
        </div>

        <div className="tabs-container mb-3">
          <nav className="tabs-nav flex-wrap justify-content-center">
            {PAGE_TABS.map((tab) => (
              <button
                key={tab.id}
                className={`tab-button ${currentTab === tab.id ? "active" : ""}`}
                onClick={() => handleChangeTab(tab.id)}
              >
                <span className="tab-label">{tab.label}</span>
              </button>
            ))}
          </nav>
        </div>

        <div className="d-block mT-2 d-sm-none">
          <h4>{PAGE_TABS.find((tab) => tab.id === currentTab)?.label}</h4>
        </div>

        <div className="tab-contentx">
          <div className="content-wrapper">{renderTabContent()}</div>
        </div>
      </div>
    </div>
  );
};

const GestionesComercialesPage = () => {
  const chosenRole = useSelector((state: RootState) => state.user.currentRole);

  const ROLE_VIEWS: Record<string, JSX.Element> = {
    COMPANY_ADMIN: <GestionesComercialesContent />,
    RRHH: <GestionesComercialesContent />,
  };

  return ROLE_VIEWS[chosenRole] ?? <></>;
};

export default GestionesComercialesPage;
